<template>
  <manageHubpallet-component>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <div class="card-header-actions">
              <router-link to="/LineHaulPalletlisting">
                <button
                  class="btn btn-sm btn-primary mr-4 btn-pill"
                  v-on:click="addapllet()"
                  type="button"
                >
                  Line Haul Pallet
                </button>
              </router-link>
              <button
                class="btn btn-sm btn-primary mr-4 btn-pill"
                v-on:click="addapllet()"
                type="button"
              >
                Add New Pallets
              </button>
              <button
                class="btn btn-sm btn-primary ml-4"
                v-on:click="refresh()"
                type="button"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>

          <div
            id="addapllet"
            style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;"
            class="mb-1"
          >
            <b-form
              @submit.prevent="validateForm('form-1')"
              data-vv-scope="form-1"
            >
              <b-row>
                <b-col md="12">
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="hf-email"
                      >Pallet Name</label
                    >
                    <div class="col-md-4">
                      <b-form-input
                        class="form-control"
                        type="text"
                        name="palletname"
                        v-model="palletname"
                        v-validate="'required|'"
                        placeholder="Enter Pallet Name"
                        :class="{
                          input: true,
                          'text-danger': errors.has('form-1.palletname'),
                        }"
                      >
                      </b-form-input>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('palletname')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.palletname')"
                          class="help text-danger"
                          >{{ errors.first("form-1.palletname") }}</span
                        >
                      </b-input-group>
                    </div>
                  </div>
                </b-col>

                <b-col sm="4">
                  <b-button variant="primary" size="md" type="submit"
                    >Save</b-button
                  >&nbsp;&nbsp;&nbsp;
                  <b-button variant="primary" size="md" @click="addclear"
                    >Clear</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
          <div id="overlay">
            <div class="loader"></div>
          </div>

          <b-col sm="12" class="text-right">
            <p>
              <b
                >Total Records :<span style="color:red;">{{
                  this.totalRows
                }}</span></b
              >
            </p>
            <b-button
              v-if="this.totalRows > 0"
              variant="primary"
              size="md"
              @click="downloadCSV"
              >Download
            </b-button>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty
              stacked="md"
              :items="items"
              :busy="isBusy"
              :fields="fields1"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :bordered="bordered"
            >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="actions" slot-scope="row">
                <div v-if="usertype=='KSA'">
                  <div v-if="row.item.pallet_title=='SFDA Pallet'||row.item.pallet_title=='WareHouse RTD Pallet'"></div>
                  <div v-else>
                    <span v-if="row.item.zone_name == null">
                      <b-button
                        size="sm"
                        @click="assignzoneModal(row.item)"
                        class="mr-1"
                        style="background: #b0c4de !important;color: #000 !important;"
                      >
                        Assign Zone
                      </b-button>
                    </span>
                    <span v-else>
                      <b-button
                        size="sm"
                        @click="updatezoneModal(row.item)"
                        class="mr-1"
                        style="background: #b0c4de !important;color: #000 !important;"
                      >
                        Update Zone
                      </b-button>
                    </span>
  
                    <span v-if="row.item.rider_name == ' '">
                      <b-button
                        size="sm"
                        @click="assignriderModal(row.item)"
                        class="mr-1"
                        style="background: #b0c4de !important;color: #000 !important;"
                      >
                        Assign Rider
                      </b-button>
                    </span>
                    <span v-else>
                      <b-button
                        size="sm"
                        @click="updateriderModal(row.item)"
                        class="mr-1"
                        style="background: #b0c4de !important;color: #000 !important;"
                      >
                        Update Rider
                      </b-button>
                    </span>
  
                    <b-button
                      size="sm"
                      @click="editinfoModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Edit </b-button
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                    <b-button
                      size="sm"
                      @click="deleteinfoModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Delete
                    </b-button>
                  </div>
                </div>
          
                <div v-else>
                  <span v-if="row.item.zone_name == null">
                    <b-button
                      size="sm"
                      @click="assignzoneModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Assign Zone
                    </b-button>
                  </span>
                  <span v-else>
                    <b-button
                      size="sm"
                      @click="updatezoneModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Update Zone
                    </b-button>
                  </span>

                  <span v-if="row.item.rider_name == ' '">
                    <b-button
                      size="sm"
                      @click="assignriderModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Assign Rider
                    </b-button>
                  </span>
                  <span v-else>
                    <b-button
                      size="sm"
                      @click="updateriderModal(row.item)"
                      class="mr-1"
                      style="background: #b0c4de !important;color: #000 !important;"
                    >
                      Update Rider
                    </b-button>
                  </span>

                  <b-button
                    size="sm"
                    @click="editinfoModal(row.item)"
                    class="mr-1"
                    style="background: #b0c4de !important;color: #000 !important;"
                  >
                    Edit </b-button
                  >&nbsp;&nbsp;&nbsp;&nbsp;
                  <b-button
                    size="sm"
                    @click="deleteinfoModal(row.item)"
                    class="mr-1"
                    style="background: #b0c4de !important;color: #000 !important;"
                  >
                    Delete
                  </b-button>
                </div>
              </template>

              <template slot="checkbox" slot-scope="row">
                <br />
                <input
                @change="setStickerHTMl($event, row.item)"
                type="radio"
                name="radAnswer"
                class="shipmentscheckbox"
                id="stiker"
                :checked="checkedData"
              />
              {{ row.item.selected }}&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button
                  size="sm"
                  id="printbutton"
                  value="print a div!"
                  @click="barcodedata('printableArea', row.item)"
                  class="mr-1"
                  style="background: #b0c4de !important;color: #000 !important;"
                >
                  Print Stiker </b-button
                >

               
              </template>
            </b-table>
          </b-col>

          <div id="printableArea">
            <div class="page-break" v-for="item in qrdetail">
              <span style="font-size: 25px;"
                ><b>{{ item.pallet_title }}</b></span
              >
              <br />


              <qr-code :text="valuess"></qr-code>
            </div>
          </div>

          <b-modal
            title="Update Pallet Name"
            v-model="editAgentMaster"
            @ok="editAgentMaster = false"
            hide-footer
          >

            <template slot="default" slot-scope="{ hide }">
              <b-form
                @submit.prevent="validateForm5('form-5')"
                data-vv-scope="form-5"
              >
                <b-form-group label="Pallet Name" :label-cols="3">
                  <b-form-input
                    type="text"
                    name="pallet Name"
                    v-model="customer.palletname"
                    v-validate="'required'"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-5.Pallet Name'),
                    }"
                    placeholder="Enter  Pallet Name"
                  >
                  </b-form-input>
                  <span
                    style="width:240px"
                    v-show="errors.has('form-5.Pallet Name')"
                    class="help text-danger"
                    >{{ errors.first("form-5.Zone Name") }}</span
                  >
                </b-form-group>

                <div slot="footer" class="text-right">
                  <b-button
                    type="submit"
                    size="sm"
                    class="mr-4"
                    variant="primary"
                  >
                    Update</b-button
                  >
                  <b-button size="sm" variant="danger" @click="editcancel()"
                    >cancel</b-button
                  >
                </div>
              </b-form>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <b-modal
            title="Update Pin Codes "
            v-model="assignzoneMaster"
            @ok="assignzoneMaster = false"
          >
            <template slot="modal-header" slot-scope="{ close }">
              <h5>Assign Zone Name</h5>
            </template>

            <template slot="default" slot-scope="{ hide }">
              <b-form-group>
                <multiselect
                  v-model="assignzonevalue"
                  tag-placeholder="Assign new Zone"
                  placeholder="Select Zone"
                  label="name"
                  track-by="id"
                  :options="assignoptions9"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag1"
                ></multiselect>
              </b-form-group>

              <div slot="footer" class="text-right">
                <b-button
                  size="sm"
                  class="mr-4"
                  variant="primary"
                  @click="assignzone()"
                >
                  Assign</b-button
                >
                <b-button size="sm" variant="danger" @click="zonecancel()"
                  >cancel</b-button
                >
              </div>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <!-- update zone model -->

          <b-modal
            title="Update Zone Name"
            v-model="updatezoneMaster"
            @ok="updatezoneMaster = false"
            hide-footer
          >
      

            <template slot="default" slot-scope="{ hide }">
              <div>
                <b-form-group>
                  <multiselect
                    v-model="value1"
                    tag-placeholder="Add new Zone"
                    placeholder="Select Zone"
                    label="name"
                    track-by="id"
                    :options="options9"
                    :multiple="true"
                    :taggable="true"
                    @tag="addTag"
                  ></multiselect>
                </b-form-group>
                
                <b-form-group label=" UID Having Shipments" :label-cols="3">
                  <b-form-textarea
                    id="textarea"
                    v-model="texts"
                    readonly
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                  <span
                    v-show="errors.has('form-1.textarea')"
                    class="help text-danger"
                    >{{ errors.first("form-1.textarea") }}</span
                  >
                </b-form-group>
              </div>

              <div slot="footer" class="text-right">
                <b-button
                  size="sm"
                  class="mr-4"
                  variant="primary"
                  @click="updatezone()"
                >
                  Update</b-button
                >
                <b-button size="sm" variant="danger" @click="updatezonecancel()"
                  >cancel</b-button
                >
              </div>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <b-modal
            title="Assign Rider Name"
            v-model="assignriderMaster"
            @ok="assignriderMaster = false"
            hide-footer
          >

            <template slot="default" slot-scope="{ hide }">
              <b-form
                @submit.prevent="validateForm4('form-5')"
                data-vv-scope="form-5"
              >
                <div>
                  <b-form-group label="Select Rider" :label-cols="4">
                   
                    <v-select
                      id="deliveryagent_from"
                      :options="data1"
                      v-model="customer.deliveryagentmasterid"
                      name="deliveryagentname"
                      v-validate="'required'"
                      :class="{ danger: errors.has('deliveryagentname') }"
                    >
                    </v-select>

                    <span
                      style="width: 270px;"
                      v-show="errors.has('form-1.deliveryagentname')"
                      class="help text-danger"
                      >{{ errors.first("form-1.deliveryagentname") }}</span
                    >
                  </b-form-group>
                </div>

                <div slot="footer" class="text-right">
                  <b-button
                    type="submit"
                    size="sm"
                    class="mr-4"
                    variant="primary"
                  >
                    Assign</b-button
                  >
                  <b-button size="sm" variant="danger" @click="ridercancel()"
                    >cancel</b-button
                  >
                </div>
              </b-form>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <b-modal
            title="Update Rider Name"
            v-model="updateriderMaster"
            @ok="updateriderMaster = false"
            hide-footer
          >

            <template slot="default" slot-scope="{ hide }">
              <b-form
                @submit.prevent="validateForm4('form-5')"
                data-vv-scope="form-5"
              >
                <div>
                  <b-form-group
                    label="Select Rider"
                    label-size="sm"
                    :label-cols="3"
                  >
                   
                    <v-select
                      id="deliveryagent_from"
                      :options="data1"
                      v-model="customer.deliveryagentmasterid"
                      name="deliveryagentname"
                      v-validate="'required'"
                      :class="{ danger: errors.has('deliveryagentname') }"
                    >
                    </v-select>

                    <span
                      style="width: 270px;"
                      v-show="errors.has('form-1.deliveryagentname')"
                      class="help text-danger"
                      >{{ errors.first("form-1.deliveryagentname") }}</span
                    >
                  </b-form-group>
                </div>

                <div slot="footer" class="text-right">
                  <b-button
                    size="sm"
                    class="mr-4"
                    variant="primary"
                    @click="updaterider()"
                  >
                    Update</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="updetridercancel()"
                    >cancel</b-button
                  >
                </div>
              </b-form>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </manageHubpallet-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueBarcode from "vue-barcode";
import Multiselect from "vue-multiselect";
export default {
  name: "managepallet",
  components: { Multiselect },
  data: function() {
    return {
      name: "managepallet",
      isBusy: false,
      breadcrumbs: [
        {
          text: "Dashboard",
          href: "/dashboard",
        },
        {
          text: "Manage Pallet",
          active: true,
        },
      ],
      add: true,
      valuess: "",
      size: 300,

      items: [],
      qrdetail: [],
      zonevalue: "",

      fields1: [
        {
          key: "pallet_title",
          label: "Pallet Name",
          sortable: true,
          tdClass: "nameOfTheClass",
        },

        {
          key: "zone_name",
          label: "Zone Name",
          sortable: true,
          sortDirection: "desc",
          tdClass: "nameOfTheClass",
        },

        {
          key: "rider_name",
          label: "Rider Name",
          sortable: true,
          sortDirection: "desc",
          tdClass: "nameOfTheClass",
        },

        { key: "actions", label: "Actions" },
        { key: "checkbox", label: "Select Radio Button", sortable: true },
      ],
      bordered: true,
      totalRows: 0,
      showSelectAll: true,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      options: [],
      checkedData: false,
      options9: [],
      data1: [],
      fields: { text: "name", value: "id" },
      zoneno: "",
      ridername: "",
      palletname: "",
      value8: [],
      ridercount: "",
      zonecount: "",
      value: [],
      printableArea: "",
      zoneoptions: [],
      tags: [],
      assignzonenamelist: [],
      tags1: [],
      //   value: [
      //   { name: 'Javascript', id: 'js' }
      // ],
      value1: [{ name: "zone", id: "js" }],
      assignvalue1: [{ name: "zone", id: "js" }],
      tags2: [],
      palletid: "",
      printtitle: "",
      pincodelist: [],
      pincodeoptions: [],
      sortDesc: false,
      allowCustomValue: true,
      sortDirection: "desc",
      filter: null,
      customer: {},
      pallet_title: "",
      printpalletid: "",
      zones: [],
      texts: [],
      zonearee: [],
      noshipments: [],
      noshipmentarr: [],
      assignzonevalue: [],
      assignoptions9: [],
      message: "",
      selected: "",
      //customer: {usertype:0 },
      editAgentMaster: false,
      assignzoneMaster: false,
      updatezoneMaster: false,
      updateriderMaster: false,
      editAgentMaster2: false,
      assignriderMaster: false,
      usertype :'',
      selectedpalletid :'',
    };
  },
  components: {
    QrcodeVue,
  },
  created: function() {
    
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.usertype = userInfo.country;
    this.displaydata();
    this.getriderlist();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.addpalletinfo();
        }
      });
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options9.push(tag);
      this.value1.push(tag);
    },
    addTag1(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.assignoptions9.push(tag);
      this.assignvalue1.push(tag);
    },
    zone: function(pid) {
      this.options9 = [];
     
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     
      const deliveryagent = {
        pallet_id: pid,
        
      };
      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getzonenamelistforpallet`,
          deliveryagent
        )
        .then((result) => {
          this.zonenamelist = result.body;
          //console.log("mmmmm"+this.zonenamelist.length);

          for (var i = 0; i < this.zonenamelist.length; i++) {
            var zone2 = {
              name: this.zonenamelist[i].zone_name,
              id: this.zonenamelist[i].zone_name,
            };
            //console.log("mmmmm"+this.zonenamelist.length);

            this.options9.push(zone2);

            // this.options.push(this.agentmaster[i].deliveryagentfirstname);
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    setStickerHTMl(e, value) {
      // this.qrvalue="";
      document.getElementById("overlay").style.display = "block";
      console.log("value",value)
      this.selectedpalletid= value.pallet_id;
      this.checkedData = true;

      const customerGetobj = {
        pallet_id: value.pallet_id,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      };

      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/palletdetailsforqrcode`,
          customerGetobj
        )
        .then((result) => {
          document.getElementById("overlay").style.display = "none";
          this.qrdetail = result.body.returnvalue;
          this.qrvalue = result.body.returnvalue[0].pallet_id;

          var qr = "" + this.qrvalue;
          // alert(qr);

          this.valuess = qr.trim();
          //alert(this.valuess);

          // console.log(this.qrvalue)
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },
    printDiv: function(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
    },
    zoneforassign: function(pid) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      //agentmaster
      const deliveryagent = {
        pallet_id: pid,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        // deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        // isactive: '1'
      };
      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getzonenamelistforpallet`,
          deliveryagent
        )
        .then((result) => {
          this.assignzonenamelist = result.body;
          //console.log("mmmmm"+this.zonenamelist.length);

          //          for(var i = 0; i < this.zonenamelist.length; i++) {
          //            var zone2 = {
          //        name: this.zonenamelist[i].zone_name,
          //        id: this.zonenamelist[i].zone_name,
          //      }
          //      //console.log("mmmmm"+this.zonenamelist.length);

          // this.zoneoptions.push(zone2);

          //        // this.options.push(this.agentmaster[i].deliveryagentfirstname);

          //       }
          if (result.body.returnmsg === "Successful") {
            this.noshipments = result.body.returnvalue[0];
            // console.log(this.noshipments.zone_not_having_shipments.length);

            // var noshipmentarr=[];
            for (
              var i = 0;
              i < this.noshipments.zone_not_having_shipments.length;
              i++
            ) {
              // console.log(this.noshipments.zone_not_having_shipments[i].zone_name);

              this.noshipmentarr.push(
                this.noshipments.zone_not_having_shipments[i].zone_name
              );
            }
          }
          // console.log(this.noshipmentarr);

          //this.assignzonenamelist.push(noshipmentarr);
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    getriderlist: function() {
      //alert("i m in riderlist")
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: "1",
        hub_id: `${userInfo.pickuplocationmasterid}`,
        hub_to_hub_delivery: "No",
      };
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`,
          deliveryagentobj
        )
        .then((result) => {
          this.data1 = result.body;

          var data = [];

          result.body.forEach(function(srData) {
            data.push({
              key: srData.deliveryagentmasterid,
              label:
                srData.deliveryagentmasterid +
                " - " +
                srData.deliveryagentfirstname +
                " - " +
                srData.deliveryagentlastname,
            });
          });

          this.data1 = data;
          this.data1.unshift({ label: "None", key: 0 });
          // console.log(this.data1);
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    addapllet: function() {
      this.errors.clear("form-1");

      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addpallet = document.getElementById("addapllet");
      addpallet.style.display = "block";
    },
    // getqrcodedetails: function(value)
    // {
    //   var pid=value.pallet_id;
    //   alert(pid);

    //    const Obj = {
    //      pallet_id:pid,

    //   }
    //  this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/palletdetailsforqrcode`, Obj)
    //     .then((result) => {
    //       this.qrdetail = result.body.returnvalue;
    //       console.log(  this.qrdetail);
    //       this.print();

    //     })
    //     .catch((ex) => {
    //       console.log('error', ex)
    //     })

    // },
    // print (value) {

    // this.printpalletid=value.pallet_id;
    //  this.printtitle=value.pallet_title;
    //   alert( this.printpalletid);
    //   // Pass the element id here
    //   this.$htmlToPaper('printMe');
    // },

    barcodedata(printableArea,value) {

      if (this.checkedData && this.selectedpalletid == value.pallet_id) {

        var printContents = document.getElementById("printableArea").innerHTML;

        var disp_setting = "toolbar=yes,location=no,";
        disp_setting += "directories=yes,menubar=yes,";
        disp_setting +=
          "scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = printContents;
        var docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
        );
        docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
        );
        docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
        );
        docprint.document.write("<head>");
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write("font-family:verdana,Arial;color:#000;");
        docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
        );
        docprint.document.write("a{color:#000;text-decoration:none;} ");
        docprint.document.write(
          ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
        );
        docprint.document.write(
          ".printarea{ font-size: 30px;text-align: center;}"
        );

        docprint.document.write(".addpad{ padding: 10px; }");

        docprint.document.write(
          "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
        );

        docprint.document.write(
          "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
        );

        docprint.document.write(".stickertable td{ padding-bottom:10px;  }");

        docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");

        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');

        docprint.document.write('</head><body onLoad="self.print()"><center>');

        // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');

        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
        docprint.document.write(content_vlue);
        docprint.document.write("</center></body></html>");
        docprint.document.close();
        // localStorage.removeItem("reloaded");
        // location.reloaded();
        //self.close();
      } else {
        alert("Please Select Radion Button");
        // this.$fire({
        //                 text:"Please Select Radion Button",
        //                 type: "warning",
        //                 timer: 30000
        //               });
      }
    },

    CloseWindow() {
      docprint.close();
    },
    addpalletinfo: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const palletsave = {
        pallet_title: this.palletname,
        created_by: `${userInfo.sysemailid}`,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      // console.log(palletsave);
      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/addnewpallet`, palletsave)
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            alert("Added successfully");
            // Utils.notify("Added successfully", "success");
            //   this.$fire({
            //   text:"Added Successfully",
            //   type: "success",
            //   timer: 30000
            // });

            this.clear();

            this.displaydata();
            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            // Utils.notify(result.body.returnvalue);
            // this.$fire({
            //       text:result.body.returnvalue,
            //       type: "error",
            //       timer: 30000
            //     });
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },
    downloadCSV: function() {
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // alert("working");
      const info = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      console.log(info);

      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslistingcsv_advanced`,
          info
        )
        .then((result) => {
          console.log(result.url);
          document.getElementById("overlay").style.display = "none";
          if (result.body == "success") {
            alert("Please Check Ur Mail For Downlod Link");
            // this.$fire({
            //          text:"Please Check Ur Mail For Downlod Link",
            //          type: "success",
            //          timer: 30000
            //        });
          } else {
            alert("Can not Download");
            // this.$fire({
            //           text:"Can not Download",
            //           type: "error",
            //           timer: 30000
            //         });
          }
          //window.location.href =result.url;
        });
    },
    //     downloadCSV: function() {

    // this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslistingcsv`)
    //         .then(result => {
    //          // console.log(result.url);
    //         window.location.href =result.url;
    //         });
    //       },

    pincodes: function() {
      //alert(" i m in pin codes");
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj = {
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/pincodelistingfornullzone`, obj)
        .then((result) => {
          this.pincodelist = result.body.returnvalue;
          for (var i = 0; i < this.pincodelist.length; i++) {
            var pins = {
              name: this.pincodelist[i].mapping_locality_id,
              id: this.pincodelist[i].mapping_locality_id,
            };
            this.pincodeoptions.push(pins);
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.updatepallettitle();
        }
      });
    },
    updatepallettitle: function() {
      //alert("Update");

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var Obj = {
        pallet_id: this.palletid,
        pallet_title: this.customer.palletname,
        created_by: `${userInfo.sysemailid}`,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      };
      // console.log(Obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/editpallet`, Obj)
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            alert("updated successfully");
            // this.$fire({
            //      text:"Updated Successfully",
            //      type: "success",
            //      timer: 30000
            //    });
            this.editAgentMaster = false;
            this.customer = {};

            this.displaydata();

            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            // Utils.notify(result.body.returnvalue);
            // this.$fire({
            //       text:result.body.returnvalue,
            //       type: "error",
            //       timer: 30000
            //     });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    addclear: function() {
      //alert(" i m in alert");
      this.customer = {};
      this.errors.clear("form-1");
      this.palletname = "";
    },

    editinfoModal: function(value) {
      this.customer.palletname = value.pallet_title;
      (this.palletid = value.pallet_id),
        (this.pallet_title = value.pallet_title);

      this.editAgentMaster = true;
    },

    deleteinfoModal: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      if (confirm("Are you sure want to delete this pallet?")) {
        var Obj = {
          pallet_id: value.pallet_id,
          // hub_id:`${userInfo.pickuplocationmasterid}`,
        };
        // console.log(Obj);

        this.$http
          .post(`${CONSTANTS.MISREPORT_API_URL}/deletepallet`, Obj)
          .then((result) => {
            if (result.body.returnmsg === "Successful") {
              alert("Deleted successfully");
              // this.$fire({
              //       text:"Deleted Successfully",
              //       type: "success",
              //       timer: 30000
              //     });

              this.displaydata();

              // this.$router.push('/managePallets');
            } else {
              alert(result.body.returnvalue);
              // Utils.notify(result.body.returnvalue);
              // this.$fire({
              //       text:result.body.returnmsg,
              //       type: "error",
              //       timer: 30000
              //     });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      }
    },
    //  printstiker: function(value)
    //  {

    // alert(" i m in print stiker");

    //  },

    assignzoneModal: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.assignoptions9 = [];
      // this.value1=[];
      this.assignzonevalue = "";
      // alert(value.pallet_id);

      //this.zoneforassign(value.pallet_id);
      const deliveryagent = {
        pallet_id: value.pallet_id,
        zonename: this.zonearee,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      // console.log(deliveryagent);

      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getzonenamelistforpallet`,
          deliveryagent
        )
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            this.noshipments = result.body.returnvalue[0];
            //console.log(this.noshipments.zone_not_having_shipments.length);

            var noshipmentarr = [];
            for (
              var i = 0;
              i < this.noshipments.zone_not_having_shipments.length;
              i++
            ) {
              //console.log(this.noshipments.zone_not_having_shipments[i].zone_name);

              noshipmentarr.push(
                this.noshipments.zone_not_having_shipments[i].zone_name
              );
            }
            this.shipments = result.body.returnvalue[1];
            var shipmentarr = [];
            for (
              var i = 0;
              i < this.shipments.zone_having_shipments.length;
              i++
            ) {
              // console.log(this.shipments.zone_having_shipments[i]);

              shipmentarr.push(this.shipments.zone_having_shipments[i]);
            }
          }

          // console.log("mmmmm"+shipmentarr);

          for (var i = 0; i < noshipmentarr.length; i++) {
            var zone2 = {
              name: noshipmentarr[i],
              id: noshipmentarr[i],
            };
            //console.log("mmmmm"+this.zonenamelist.length);

            this.assignoptions9.push(zone2);
            this.texts = shipmentarr;

            // this.options.push(this.agentmaster[i].deliveryagentfirstname);
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
      this.palletid = value.pallet_id;
      this.assignzoneMaster = true;
    },

    //mukeshworking
    updatezoneModal: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.value1 = [];
      this.options9 = [];
      var a = [];
      a = value.zone_name.split(",");
      // console.log(a.length);
      // console.log(a);

      for (var i = 0; i < a.length; i++) {
        // console.log("mukesh");
        //alert(a[i]);

        const tag = {
          name: a[i],
          id: a[i],
        };
        this.value1.push(tag);
      }

      // alert(" i m in update");

      // this.zonevalue=value.zone_name.split( ",");
      //  this.tags=value.zone_name.split( ",");
      // this.zone(value.pallet_id,v);
      //  var Zonenames = value.zone_name;
      //   var zonenameArr = Zonenames.split(',');

      // this.customer.zones=zonenameArr;
      (this.palletid = value.pallet_id),
        (this.zonearee = value.zone_name.split(","));
      this.options9 = [];
      // this.value1=[];
      this.zonevalue = "";

      const deliveryagent = {
        pallet_id: this.palletid,
        zonename: this.zonearee,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      this.$http
        .post(
          `${CONSTANTS.MISREPORT_API_URL}/getzonenamelistforpallet`,
          deliveryagent
        )
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            this.noshipments = result.body.returnvalue[0];
            //console.log(this.noshipments.zone_not_having_shipments.length);

            var noshipmentarr = [];
            for (
              var i = 0;
              i < this.noshipments.zone_not_having_shipments.length;
              i++
            ) {
              //console.log(this.noshipments.zone_not_having_shipments[i].zone_name);

              noshipmentarr.push(
                this.noshipments.zone_not_having_shipments[i].zone_name
              );
            }
            this.shipments = result.body.returnvalue[1];
            var shipmentarr = [];
            for (
              var i = 0;
              i < this.shipments.zone_having_shipments.length;
              i++
            ) {
              // console.log(this.shipments.zone_having_shipments[i]);

              shipmentarr.push(this.shipments.zone_having_shipments[i]);
            }
          }

          // console.log("mmmmm"+shipmentarr);

          for (var i = 0; i < noshipmentarr.length; i++) {
            var zone2 = {
              name: noshipmentarr[i],
              id: noshipmentarr[i],
            };
            //console.log("mmmmm"+this.zonenamelist.length);

            this.options9.push(zone2);
            this.texts = shipmentarr;

            // this.options.push(this.agentmaster[i].deliveryagentfirstname);
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });

      this.updatezoneMaster = true;
    },
    updatezone: function() {
      // alert("update Zone");
      //console.log("mukesh"+this.value1[0].id);

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // {"pallet_id":"1","zone_name":["Zone 11","Zone 12"]}
      if (this.value1.length > 0) {
        var zonelistarr = [];
        for (var i = 0; i < this.value1.length; i++) {
          zonelistarr.push(this.value1[i].id);
        }

        for (var i = 0; i < this.texts.length; i++) {
          zonelistarr.push(this.texts[i]);
        }

        var Obj = {
          pallet_id: this.palletid,
          zone_name: zonelistarr,
          // hub_id:`${userInfo.pickuplocationmasterid}`,
        };
      } else {
        //alert(" i m in else");
        var zonelistarr = [];
        for (var i = 0; i < this.texts.length; i++) {
          zonelistarr.push(this.texts[i]);
        }
        var Obj = {
          pallet_id: this.palletid,
          zone_name: zonelistarr,
          // hub_id:`${userInfo.pickuplocationmasterid}`,
        };
      }

      // console.log(Obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/updatezonetopallet`, Obj)
        .then((result) => {
          if (result.body.returnmsg === "successful") {
            alert("updated successfully");
            // this.$fire({
            //      text:"Updated Successfully",
            //      type: "success",
            //      timer: 30000
            //    });
            this.updatezoneMaster = false;
            this.customer = {};

            this.displaydata();

            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            //Utils.notify(result.body.returnvalue);
            // this.$fire({
            //      text:result.body.returnvalue,
            //      type: "error",
            //      timer: 30000
            //    });
            this.updatezoneMaster = false;
            this.customer = {};
            this.displaydata();
            // this.$router.push('/managePallets');
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.assignrider();
        }
      });
    },

    assignrider: function() {
      // alert("assign rider");

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // {"pallet_id":"1","deliveryagentmasterid":"454"}
      var Obj = {
        pallet_id: this.palletid,
        deliveryagentmasterid: this.customer.deliveryagentmasterid.key,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      // console.log(Obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/assignridertopallet`, Obj)
        .then((result) => {
          if (result.body.returnmsg === "successful") {
            alert("Assigned successfully");
            // this.$fire({
            //      text:"Assigned Successfully",
            //      type: "success",
            //      timer: 30000
            //    });
            this.assignriderMaster = false;
            this.customer = {};

            this.displaydata();

            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            // Utils.notify(result.body.returnvalue);
            // this.$fire({
            //      text:result.body.returnvalue,
            //      type: "error",
            //      timer: 30000
            //    });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    updaterider: function() {
      //alert("update rider");

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // {"pallet_id":"1","deliveryagentmasterid":"454"}
      var Obj = {
        pallet_id: this.palletid,
        deliveryagentmasterid: this.customer.deliveryagentmasterid.key,
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };
      // console.log(Obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/updateridertopallet`, Obj)
        .then((result) => {
          if (result.body.returnmsg === "successful") {
            alert("updated successfully");
            // this.$fire({
            //      text:"Updated Successfully",
            //      type: "success",
            //      timer: 30000
            //    });
            this.updateriderMaster = false;
            this.customer = {};

            this.displaydata();

            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            // Utils.notify(result.body.returnvalue);
            // this.$fire({
            //      text:result.body.returnvalue,
            //      type: "error",
            //      timer: 30000
            //    });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    assignriderModal: function(value) {
      this.palletid = value.pallet_id;

      this.assignriderMaster = true;
    },
    assignzone: function() {
      //alert("assign Zone");
      //console.log(this.assignzonevalue) ;

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // {"pallet_id":"1","zone_name":["Zone 11","Zone 12"]}
      //     var dropzonelistarr=[];
      //          for(var i = 0; i < this.tags1.length; i++) {
      //           if(this.tags1[i].text== null || this.tags1[i].text=="undefined" || this.tags1[i].text=="")
      //         {
      //           dropzonelistarr.push(this.tags1[i]);

      //         }
      //           else
      //           {
      //              dropzonelistarr.push(this.tags1[i].text);
      //           }
      // console.log("val1"+this.tags1[i]);

      //        }

      var assignzonelistarr = [];
      for (var i = 0; i < this.assignzonevalue.length; i++) {
        //console.log(this.assignoptions9[i].id)
        assignzonelistarr.push(this.assignzonevalue[i].id);
      }

      // console.log(assignzonelistarr)

      var Obj = {
        pallet_id: this.palletid,
        zone_name: assignzonelistarr,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      };
      // console.log(Obj);

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/assignzonetopallet`, Obj)
        .then((result) => {
          if (result.body.returnmsg === "successful") {
            alert("Assigned successfully");
            // this.$fire({
            //       text:"Assigned Successfully",
            //       type: "success",
            //       timer: 30000
            //     });
            this.assignzoneMaster = false;
            this.customer = {};

            this.displaydata();

            // this.$router.push('/managePallets');
          } else {
            alert(result.body.returnvalue);
            // Utils.notify(result.body.returnvalue);
            // this.$fire({
            //      text:result.body.returnvalue,
            //      type: "error",
            //      timer: 30000
            //    });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    updateriderModal: function(value) {
      // console.log(value.deliveryagentmaster_id);
      this.customer.deliveryagentmasterid =
        value.deliveryagentmaster_id + "-" + value.rider_name;
      //this.tags=value.zone_name.split( ",");
      //console.log("final testing"+this.customer.deliveryagentmasterid);
      this.palletid = value.pallet_id;

      this.updateriderMaster = true;
    },

    editcancel: function() {
      this.tags = [];
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
    },
    zonecancel: function() {
      //   this.tags=[];
      // this.customer = {};
      this.assignzoneMaster = !this.assignzoneMaster;
    },
    updatezonecancel: function() {
      //   this.tags=[];
      // this.customer = {};
      this.updatezoneMaster = !this.updatezoneMaster;
    },
    //   editcancel2: function() {
    //   //   this.tags=[];
    //   // this.customer = {};
    //   this.editAgentMaster2 = !this.editAgentMaster2;

    // },
    ridercancel: function() {
      //   this.tags=[];
      // this.customer = {};
      this.assignriderMaster = !this.assignriderMaster;
    },
    updetridercancel: function() {
      //   this.tags=[];
      // this.customer = {};
      this.updateriderMaster = !this.updateriderMaster;
    },

    refresh: function() {
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addpallet = document.getElementById("addapllet");
      addpallet.style.display = "none";
      this.clear();
    },
    GetSortOrder: function(prop) {
      return function(a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },

    displaydata: function() {
      // alert("Tab inn");
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // alert(userInfo.pickuplocationmasterid);
      this.isBusy = true;
      const obj = {
        // hub_id:"",
        hub_id: `${userInfo.pickuplocationmasterid}`,
        hub_to_hub_pallet: "No",
      };
      //  alert("zone & pin codes");

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslisting`, obj)
        .then((result) => {
          this.isBusy = false;
          if ((result.body.returnmsg = "Successful")) {
            this.items = result.body.returnvalue;

            this.totalRows = result.body.returnvalue.length;

            // this.isBusy = !this.isBusy;
          } else {
            this.items = [];
            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    clear: function() {
      this.palletname = "";

      this.errors.clear("form-1");
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.nameOfTheClass {
  max-width: 450px;
}

.nameOfTheClass1 {
  width: 290px;
}
.ti-new-tag-input-wrapper input[data-v-61d92e31] {
  flex: 1 0 auto;
  min-width: 310px;
  border: none;
  padding: 0px;
  margin: 0px;
}
#deliveryagent_from {
  width: 230px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*.modal-body {
    
    height: 450px;
}*/
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
